const state = () => ({
    _show: false,
});

const getters = {
    starterShow: (state) => state.show,
};

const actions = {
    handleChangeStatus(status) {
        this._setStarterConversationChangeStatus(status);
    },

    _setStarterConversationChangeStatus(status) {
        this._show = status;
    },
};

export default {
    state,
    getters,
    actions,
};
